import { createAction, props } from "@ngrx/store";

export const fetchRoles = createAction('[Roles] Fetch Roles');
export const rolesFetched = createAction('[Roles] Roles Fetched', props<{ roles: string[] }>());
export const roleError = createAction('[Roles] Role Error', props<{ error: string }>());
